module.exports = __webpack_public_path__ + "img/banner.ed95f512.png";